(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  var isInVisibleRange = function($window, e) {
    return (Math.round(e.getBoundingClientRect().top) - (e.getAttribute('vv-on-visible-bind-range') || 400)
    < Math.max($window.document.documentElement.clientHeight, $window.innerHeight));
  };

  var onScrollHandlerBound = false;
  var jobPromise = null;

  var bindOnScrollHandler = function($window, vv, $timeout) {
    if (!onScrollHandlerBound) {
      var task = function () {
        var elements = vv.$('.vvOnVisibleBind');
        for (var i = 0; i < elements.length; i++) {
          var e = elements[i];
          if (isInVisibleRange($window, e)) {
            var ae = angular.element(e);
            ae.trigger('vvVisible');
          }
        }
      };
      var onScrollHandler = function () {
        if (jobPromise != null) {
          $timeout.cancel(jobPromise);
        }
        jobPromise = $timeout(task, 50);
      };
      angular.element($window).on('scroll', onScrollHandler);
      angular.element($window).on('resize', onScrollHandler);

      onScrollHandlerBound = true;
    }
  };

  m.directive('vvOnVisibleBind', function($window, vv, $timeout, $rootScope) {
    return {
      restrict: 'A',
      scope: {'vvOnVisibleBind': '='},
      link: function(scope, elem, attrs) {
        scope.vvOnVisibleBind = false;
        elem.addClass('vvOnVisibleBind');

        var handlerFunc = function() {
          var e = elem[0];
          if (isInVisibleRange($window, e)) {
            scope.vvOnVisibleBind = true;
            elem.removeAttr('vv-on-visible-bind');
            elem.removeClass('vvOnVisibleBind');
          }
        };
        elem.on('vvVisible', handlerFunc);
        if ($rootScope.hasLoadingLayer && $rootScope.hasLoadingLayer()) {
          scope.$on('loadingLayerRemoved', handlerFunc);
        } else {
          $timeout(handlerFunc, 0);
        }
        bindOnScrollHandler($window, vv, $timeout);
      }
    };
  });
})(window, window.angular);
